import {useEffect, useState} from "react";
import apiClient from "../lib/apiClient";
import isLocalDev from "../lib/isLocalDev";

export default function EditFamilyOffice() {
  const [familyOffice, setFamilyOffice] = useState(null);
  const [users, setUsers] = useState([]);
  const [addingUser, setAddingUser] = useState(false);

  useEffect(() => {
    apiClient.get("/api/family_office/users")
      .then(({ data }) => {
        setUsers(data.users);
        setFamilyOffice(data.family_office);
      }).catch(console.error);
  }, []);

  if (!isLocalDev()) {
    return <h1>Under Construction</h1>
  }

  return <div className="container">
    <div className="row">
      <div className="col">
        <div className="card">
          <div className="card-header">
            <h2>Family Office</h2>
          </div>
          <div className="card-body">
            <form>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input value={familyOffice?.name} type="text" className="form-control" id="name" />
              </div>
              <div className="mb-3  w-100">
                <table className="table table-sm w-100">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Role</th>
                      <th/>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(user => <tr key={user.id}>
                      <td className='pe-3'>{user.email}</td>
                      <td className='pe-3'>{user.role}</td>
                      <td className="">
                        {user.role !== 'owner' &&

                          <a href="#" className="text-danger">
                            <i className={"bi bi-trash"} />
                            Remove
                          </a>
                        }
                      </td>
                    </tr>)}
                    {!addingUser && <tr>
                      <td colSpan={2}/>
                      <td>
                        <a href="#" onClick={() => setAddingUser(true)}>
                          <i className={"bi bi-person-fill-add"} />
                          Add User
                        </a>
                      </td>
                    </tr>}
                    {addingUser && <tr>
                      <td>
                        <input type="email" className="form-control" />
                      </td>
                      <td>
                        <select className="form-select">
                          <option value='member'>Member</option>
                          <option value='editor'>Editor</option>
                        </select>
                      </td>
                      <td>
                      <a href="#" onClick={() => setAddingUser(false)}>Cancel</a>
                      </td>
                    </tr>}
                  </tbody>
                </table>
              </div>
              <button type="submit" className="btn btn-primary">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
}